import styled from "@emotion/styled";
import { Component } from "react";

import { DesignToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import { Pagination } from "components/pagination";
import { TicketsRoutes } from "constants/tickets/TicketsRoutes";
import { MAX_SEARCH_RESULTS } from "constants/tickets/search";
import { addCommas, plural } from "utils/string";

interface IProps {
  selectedIds: string[];
  route: TicketsRoutes;
  ticketsFromOtherTeamsAllowed: boolean;
  currentPage: number;
  totalPages: number;
  totalResults: number;
  isDataFresh?: boolean;
  supportsBatchUpdate?: boolean;
  onPageChange(page: number): void;
  onAllTicketsLinkClick(): void;
}

export class TicketsPagination extends Component<IProps> {
  shouldComponentUpdate(nextProps: IProps): boolean {
    return nextProps.isDataFresh !== false || nextProps.selectedIds !== this.props.selectedIds;
  }

  render(): JSX.Element {
    const { currentPage, totalPages, supportsBatchUpdate, selectedIds, totalResults, onPageChange } = this.props;

    const totalResultsLabel =
      totalResults <= MAX_SEARCH_RESULTS ? addCommas(totalResults) : `${addCommas(MAX_SEARCH_RESULTS)}+`;

    const selectedTicketsMessage = supportsBatchUpdate && selectedIds.length > 0 ? `${selectedIds.length} of ` : "";

    return (
      <Wrapper>
        <TotalResults size="sm">
          {selectedTicketsMessage}
          {totalResultsLabel} {plural(totalResults, "ticket", "tickets")}
        </TotalResults>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalPagesLimit={500}
          onPageChange={onPageChange}
        />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: var(${SpacingToken.Spacing8});
  border-bottom: 1px solid var(${DesignToken.BorderBasicSecondary});
  padding: 0 var(${SpacingToken.Spacing2});
`;

const TotalResults = styled(Text)`
  color: var(${DesignToken.ContentBasicSecondary});
`;
